<template>
  <div id="callback">
  </div>
</template>

<script>
  import Oidc from 'oidc-client'
  import config from '../../appsettings.js'

  export default {
    name: 'callback',
    methods: {
    },
    mounted() {
      var mgr = new Oidc.UserManager({
        userStore: new Oidc.WebStorageStateStore({ store: window.localStorage })
      });

      var goHome = function (user) {
        window.location.href = config.WELCOME_URL;
      };

      mgr.signinRedirectCallback()
        .then(user => goHome(user))
        .catch(_ => goHome());
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/auth/callback.vue